import React from "react";
import PropTypes from 'prop-types';
import MyInput from '../../components/controls/MyInput';
import _AdminService from "../../modules/AdminService";
import moment from "moment";
import _utils from '../../modules/Utils';
import { Spin, Collapse } from "antd";
import ButtonComponent from 'components/controls/Button';
import _notification from 'modules/notification';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
const { Panel } = Collapse;

class CandidateReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            posts: [],
            loading: true,
            studentPersonalModel: {},
            challanBankDetailModel: {},
            studentReservationModel: {},
        };
    }

    componentDidMount() {
        this.getStudentPersonalData();
    }

    getStudentPersonalData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    //console.log("Application ID: ", this.props.popupData.Application_Id);
                    let response = await _AdminService.GetStudentDataForReview(this.props.popupData.Application_Id);
                    //console.log("Summary Data:  ", response.data);
                    this.setState({
                        data: response.data,
                        studentPersonalModel: response.data.studentPersonalModel,
                        challanBankDetailModel: response.data.challanBankDetailModel,
                        studentReservationModel: response.data.studentReservationModel,
                        otherInformationModel: response.data.otherInformationModel,
                        loading: false
                    });

                } catch (e) {
                    // TODO 
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onFormStatusUpdate = (value) => {
        //console.log('Student status: ', value);
        if (value < 1) {
            return
        }
        //console.log('Student status 1: ', value);
        const params = {
            ApplicationID: this.props.popupData.Application_Id,
            Is_Approved_Rejected: value,
            Reason_Approved_Rejected: ""
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.UpdateStudentApprovedRejectedData(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        if (value == 1) {
                            _notification.showMessage('success', "Form has been approved.");
                        }
                        if (value == 2) {
                            _notification.showMessage('success', "Form has been rejected.");
                        }
                        if (value == 3) {
                            _notification.showMessage('success', "Form has been put on hold.");
                        }

                        this.props.onCancel();
                        this.props.onStateChange();
                        this.setState({
                            loading: false,
                        });
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    };

    render() {
        if (this.state.loading)
            return <Spin size="large" />

        return (
            <div className="">
                <div className="row">
                    {!this.state.data.IsRoleNumberGenerated ?
                        <div className="col-12 mb-2" style={{ "marginTop": "15px" }}>
                            <div className=" form-action d-flex justify-content-end">
                                <ButtonComponent
                                    id="btnSubmit"
                                    type="button"
                                    value="Reject"
                                    onClick={() => this.onFormStatusUpdate(2)}
                                    className="btn-primary button mr-4" />

                                <ButtonComponent
                                    id="btnPrint"
                                    type="button"
                                    value="Approve"
                                    onClick={() => this.onFormStatusUpdate(1)}
                                    className="btn-tertiary" />
                            </div>
                        </div> :
                        <div className="col-12" style={{ "marginTop": "15px" }}>
                            <div className=" form-action d-flex justify-content-end">
                                <label className="font-italic">Roll numbers are generated for the applied post, Approve/Reject actions are not allowed.</label>
                            </div>
                        </div>
                    }
                </div>
                {/* <h6 className="mb-4">{this.props.message}</h6> */}
                <div className="review_Data_Table my-2 " style={{ display: 'inline-table', width: '100%', height: '100%' }}>
                    <Collapse collapsible="header" defaultActiveKey={['1']}>
                        <Panel header="General Information" key="1">
                            <div className="general_information">
                                <div style={{ width: '100%' }}>
                                    <div className="general_information">
                                        <label>Form No: </label>
                                        <span style={{ color: 'red' }}>{this.state.data.studentPersonalModel.Form_Number}</span>
                                    </div>
                                    <div className="general_information">
                                        <label>Applied Post :</label>
                                        <span>{this.state.data.studentPersonalModel.Applied_Post}</span>
                                    </div>
                                    <div className="general_information">
                                        <label>Fees :</label>
                                        <span>{this.state.data.studentPersonalModel.Exam_Fee}</span>
                                    </div>
                                    <div className="general_information">
                                        <label>Form Submit Date :</label>
                                        <span>{moment(this.state.data.studentPersonalModel.Submitted_Date).isValid() ? moment(this.state.data.studentPersonalModel.Submitted_Date).format("DD-MMM-YYYY h:mm:ss a") : 'N/A'}</span>
                                    </div>
                                    {this.state.data.studentPersonalModel.Roll_Number ?
                                        <div className="general_information">
                                            <label>Roll Number :</label>
                                            <span style={{ fontWeight: "bold", color: 'green', backgroundColor: '#fffb04', marginLeft: '10px' }}>{this.state.data.studentPersonalModel.Roll_Number}</span>
                                        </div> : <></>
                                    }
                                </div>
                                <div style={{ width: '100%' }}>
                                    <div className="general_information">
                                        <label>Application No: </label>
                                        <span style={{ color: 'red' }}>{this.state.data.studentPersonalModel.Application_Id}</span>
                                    </div>

                                    <div className="general_information">
                                        <label>Transaction Id :</label>
                                        <span>{this.state.data.studentPersonalModel.Challan_Transaction_Id}</span>
                                    </div>
                                    <div className="general_information">
                                        <label style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}>Bank &nbsp;Transaction Id :</label>
                                        <label style={{ fontSize: '14px', fontWeight: "bold", color: 'blue', marginLeft: '10px' }}>{this.state.data.studentPersonalModel.Submitted_Challan_Transaction_Id}</label>
                                    </div>
                                    <div className="general_information">
                                        <label>Form Status :</label>
                                        <span style={{ fontWeight: "bold", color: 'green', backgroundColor: '#fffb04', marginLeft: '10px' }}>{this.state.data.studentPersonalModel.Is_Approved_Rejected == 1 ? "Approved" : this.state.data.studentPersonalModel.Is_Approved_Rejected == 2 ? "Rejected" : "Review Pending"}</span>
                                    </div>
                                    <div className="general_information">
                                        <label>AADHAR : &nbsp;&nbsp;</label>
                                        <a download="Aadhaar" href={this.state.data.studentPersonalModel.Aadhar_Image_Path}> Download</a>
                                        {/* <span style={{ fontWeight: "bold", color: 'green', backgroundColor: '#fffb04', marginLeft: '10px' }}>{this.state.data.studentPersonalModel.Aadhar_Image_Path}</span> */}
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>

                    <Collapse collapsible="header" defaultActiveKey={['1']}>
                        <Panel header="Personal Information" key="1">
                            <table className='table_100_percent tableHiddenBorder'>
                                <tbody>
                                    <tr>
                                        <td className='table_personal_info_review' style={{ padding: 0, borderStyle: 'hidden' }}>
                                            <table style={{ width: '100%' }}>
                                                <tbody>
                                                    <tr>
                                                        <th>Full Name</th>
                                                        <td>{(this.state.data.studentPersonalModel.First_Name) + ' ' +
                                                            (this.state.data.studentPersonalModel.Middle_Name) + ' ' +
                                                            (this.state.data.studentPersonalModel.Last_Name)}
                                                        </td>
                                                    </tr>
                                                    <tr style={{ height: '25px' }}>
                                                        <th>Father's Name</th>
                                                        <td>{this.state.data.studentPersonalModel.Father_Name}</td>
                                                    </tr>
                                                    <tr>
                                                        <th> Mother's Name</th>
                                                        <td>{this.state.data.studentPersonalModel.Mother_Name}</td>
                                                    </tr>
                                                    <tr>
                                                        <th> Contact No.</th>
                                                        <td><span>Mobile No. : </span>{this.state.data.studentPersonalModel.Mobile_Number} <span> Email : </span>{this.state.data.studentPersonalModel.Email}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Address</th>
                                                        <td>
                                                            <div>
                                                                {this.state.data.studentPersonalModel.Address}
                                                            </div>
                                                            <span>Village/City : </span>{this.state.data.studentPersonalModel.Village}, { }
                                                            <span>Taluka : </span>{this.state.data.studentPersonalModel.Taluka}, { }
                                                            <span>Dist : </span>{this.state.data.studentPersonalModel.District}, { }
                                                            <span>Pin Code : </span>{this.state.data.studentPersonalModel.Pin_Code}, { }
                                                            <span>State : </span>{this.state.data.studentPersonalModel.State} { }
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={2}>
                                                            <label style={{ marginRight: '20rem', display: 'inline', fontSize: '14px' }}><span>Gender :</span> {this.state.data.studentPersonalModel.Gender}</label>
                                                            <label style={{ display: 'inline', fontSize: '14px' }}><span>Date Of Birth :</span>{moment(this.state.data.studentPersonalModel.Birth_Date).format('DD-MMM-YYYY')}</label><br></br>
                                                            {/* <label style={{ marginRight: '18rem', display: 'inline', fontSize: '14px' }}><span>Number Of Child :</span> {(this.state.data.studentPersonalModel.Number_Of_Children) === null ? 0 : (this.state.data.studentPersonalModel.Number_Of_Children)}</label> */}
                                                            <label style={{ display: 'inline', fontSize: '14px' }}><span>Marital Status : </span>{this.state.data.studentPersonalModel.Marital_Status}</label>
                                                        </td>
                                                    </tr>
                                                    {this.state.data.studentPersonalModel.IsDrivingLicenceMandatory && <tr style={{ height: '25px' }}>
                                                        <th>Driving Licence No.</th>
                                                        <td>{this.state.data.studentPersonalModel.DrivingLicenceNumber}</td>
                                                    </tr>}
                                                </tbody>
                                            </table>
                                        </td>
                                        <td style={{ borderStyle: 'hidden' }}>
                                            <div>
                                                <div className='textAlignCenter'>
                                                    <img className='receipt_details_profile_img' src={this.state.data.studentPersonalModel.Profile_Pic_Path} alt="Profile" />
                                                </div>
                                                <div className='textAlignCenter'>
                                                    <img className='receipt_details_signature_img' src={this.state.data.studentPersonalModel.Signature_Path} alt="Signature" />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Panel>
                    </Collapse>

                    <Collapse collapsible="header" defaultActiveKey={['1']}>
                        <Panel header="Reservation Details" key="1">
                            <table className='table_reservation_review'>
                                <tbody>
                                    <tr>
                                        <td>
                                            <label style={{ marginRight: '12rem', display: 'inline', fontSize: '14px' }}><span>Category : </span>{this.state.data.studentReservationModel.Category}</label>
                                        </td>
                                        <td>
                                            <label style={{ marginRight: '12rem', display: 'inline', fontSize: '14px' }}><span>Caste : </span>{this.state.data.studentReservationModel.Caste}</label>
                                        </td>
                                        <td colSpan={2}>
                                            <label style={{ display: 'inline', fontSize: '14px' }}><span> Non Creamy Layer : </span>{(this.state.data.studentReservationModel.Is_NonCreamyLayer_Available) === true ? 'Yes' : 'No'}</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Physically Handicaped</th>
                                        <td>{(this.state.data.studentReservationModel.Is_Handicaped) === true ? 'Yes' : 'No'}</td>
                                        <th>Sports</th>
                                        <td>{(this.state.data.studentReservationModel.Is_Player) === true ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <th>Earth Quake Affected</th>
                                        <td>{(this.state.data.studentReservationModel.Earth_Quake_Affected) === true ? 'Yes' : 'No'}</td>
                                        <th>Anshkalin</th>
                                        <td>{(this.state.data.studentReservationModel.Is_Anshkalin) === true ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <th>Ex Serviceman</th>
                                        <td>{(this.state.data.studentReservationModel.Ex_Serviceman) === true ? 'Yes' : 'No'}</td>
                                        <th>Female</th>
                                        <td>{(this.state.data.studentReservationModel.Is_Ladies) === true ? 'Yes' : 'No'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Panel>
                    </Collapse>

                    <Collapse collapsible="header" defaultActiveKey={['1']}>
                        <Panel header="Qualification Details" key="1">
                            <table className='table_qualification_review mt-3'>
                                <tbody>
                                    <tr>
                                        <th>Education</th>
                                        <th>Specialisation</th>
                                        <th>Name of Board/University</th>
                                        <th>Year Of Passing</th>
                                        <th>Marks (%)</th>
                                        <th>Class</th>
                                    </tr>

                                    {this.state.data.studentQualificationDetailModels.map((item, index) => (

                                        <tr data-index={index}>
                                            <th>{item.Qualification}</th>
                                            <td>{item.Qualification == "Other" ? item.Other_Information : item.Specilisation}</td>
                                            <td>{item.University_Name}</td>
                                            <td>{item.Passed_Year}</td>
                                            <td>{item.Percentage_Grade}</td>
                                            <td>{item.Class}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Panel>
                    </Collapse>


                    <Collapse collapsible="header" defaultActiveKey={['1']}>
                        <Panel header="Other Skills & Experience Details" key="1">
                            <table className='table_experience_review'>
                                <tbody>
                                    <tr>
                                        <td colSpan={2}>
                                            <span>Typing Details</span>
                                        </td>
                                        <td colSpan={2}>
                                            <span>Short Hand Details</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Marathi Typing 30</th>
                                        <td>{(this.state.otherInformationModel.Is_Marathi_Typing_30) === true ? 'Yes' : 'No'}</td>
                                        <th>100 Words/minutes</th>
                                        <td>{(this.state.otherInformationModel.Is_100_WPM) === true ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <th>English Typing 40</th>
                                        <td>{(this.state.otherInformationModel.Is_English_Typing_40) === true ? 'Yes' : 'No'}</td>
                                        <th>120 Words/minutes</th>
                                        <td>{(this.state.otherInformationModel.Is_120_WPM) === true ? 'Yes' : 'No'}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4}>
                                            <span>Experience Details</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Organization Name
                                        </th>
                                        <th>Designation
                                        </th>
                                        <th>From Date
                                        </th>
                                        <th>To Date
                                        </th>
                                    </tr>

                                    {this.state.otherInformationModel && this.state.otherInformationModel.map((item, index) => (<>
                                        <tr data-index={index}>
                                            <td>{item.Organisation ? item.Organisation : "N/A"}</td>
                                            <td>{item.Designation ? item.Designation : "N/A"}</td>
                                            <td>{item && item.From_Date ? moment(item.From_Date).format('DD-MMM-YYYY') : "N/A"}</td>
                                            <td>{item && item.To_Date ? moment(item.To_Date).format('DD-MMM-YYYY') : "N/A"}</td>
                                        </tr>
                                    </>
                                    ))}
                                    {/* <tr>
                                        <th>Organization Name</th>
                                        <td>{this.state.otherInformationModel.Organisation}</td>
                                        <th>Designation</th>
                                        <td>{this.state.otherInformationModel.Designation}</td>
                                    </tr>
                                    <tr>
                                        <th>From Date</th>
                                        <td>
                                            {this.state.otherInformationModel.From_Date ? moment(this.state.otherInformationModel.From_Date).format('DD-MMM-YYYY') : ""}
                                        </td>
                                        <th>To Date</th>
                                        <td>
                                            {this.state.otherInformationModel.To_Date ? moment(this.state.otherInformationModel.To_Date).format('DD-MMM-YYYY') : ""}
                                        </td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </Panel>
                    </Collapse>
                </div>
                <div className="row">
                    {!this.state.data.IsRoleNumberGenerated ?
                        <div className="col-12" style={{ "marginTop": "15px" }}>
                            <div className=" form-action d-flex justify-content-end">
                                <ButtonComponent
                                    id="btnSubmit"
                                    type="button"
                                    value="Reject"
                                    onClick={() => this.onFormStatusUpdate(2)}
                                    className="btn-primary button mr-4" />

                                <ButtonComponent
                                    id="btnPrint"
                                    type="button"
                                    value="Approve"
                                    onClick={() => this.onFormStatusUpdate(1)}
                                    className="btn-tertiary" />
                            </div>
                        </div> :
                        <div className="col-12" style={{ "marginTop": "15px" }}>
                            <div className=" form-action d-flex justify-content-end">
                                <label className="font-italic">Roll numbers are generated for the applied post, Approve/Reject actions are not allowed.</label>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default CandidateReview;

// 0 - Not Submitted                (Student is filling his form)
// 1 - Approved                     (Reviewed by reviewer and approved)
// 2 - Rejected                     (Form rejected and Provided reason for rejection
